<ng-container *ngIf="selectorData && selectorData.length">
    <app-custom-selector [minimumSelectorListCount]='minimumListCount' [selectorData]="selectorData" (emitSelectedValue)="onChangeSelector($event)"></app-custom-selector>
</ng-container>